import { replaceValueAtKeyPath } from './replaceValueAtKeyPath'

export interface UpdateObjParams {
	object: any
	keyPath: (string | number)[]
	value?: any
	operation?: 'setValue' | 'changeAt' | 'push' | 'pop' | 'removeKey' | 'replace'
}
export const updateObj = ({
	object,
	keyPath,
	value,
	operation,
}: UpdateObjParams) => {
	let valueAtKeyPath = keyPath?.reduce((acc, key) => acc?.[key], object)
	let lastKey = keyPath?.[keyPath?.length - 1]
	let keyPathOfParent = keyPath?.slice(0, keyPath?.length - 1)
	let valueOfParent = keyPathOfParent?.reduce((acc, key) => acc?.[key], object)

	switch (operation) {
		case 'setValue':
		case 'changeAt': {
			if (Array.isArray(valueOfParent)) {
				let newValueOfParent = [...valueOfParent]
				newValueOfParent?.splice(lastKey as number, 1, value)
				return replaceValueAtKeyPath(object, keyPathOfParent, newValueOfParent)
			} else {
				return replaceValueAtKeyPath(object, keyPath, value)
			}
		}
		case 'push': {
			let newValue = [...valueAtKeyPath]
			newValue?.push(value)
			return replaceValueAtKeyPath(object, keyPath, newValue)
		}
		case 'pop': {
			let newValue = [...valueAtKeyPath]
			newValue?.pop()
			return replaceValueAtKeyPath(object, keyPath, newValue)
		}
		case 'removeKey': {
			if (Array.isArray(valueOfParent)) {
				let newValueOfParent = [...valueOfParent]
				newValueOfParent?.splice(lastKey as number, 1)
				return replaceValueAtKeyPath(object, keyPathOfParent, newValueOfParent)
			} else {
				let newValueOfParent = { ...valueOfParent }
				delete newValueOfParent?.[lastKey as string]
				return replaceValueAtKeyPath(object, keyPathOfParent, newValueOfParent)
			}
		}
		case 'replace': {
			let newValueOfParent = { ...valueOfParent }
			newValueOfParent[value as string] = valueAtKeyPath
			delete newValueOfParent?.[lastKey as string]
			return replaceValueAtKeyPath(object, keyPathOfParent, newValueOfParent)
		}
	}
}

/*export const updateObj = (updateParamsIn: UpdateObjParams) => {
	if (updateParamsIn.keyPath.length === 1) {
		const key = updateParamsIn.keyPath[0]
		let object
		if (Array.isArray(updateParamsIn.object)) {
			object = [...updateParamsIn.object] ?? []
		} else {
			object = { ...updateParamsIn.object } ?? {}
		}
		if (updateParamsIn.operation === 'removeKey') {
			if (Array.isArray(object)) {
				object?.splice(key as number, 1)
			} else {
				delete object?.[key]
			}
		} else if (
			updateParamsIn.operation === 'setValue' ||
			updateParamsIn.operation === 'changeAt'
		) {
			object[key] = updateParamsIn.value
		} else if (updateParamsIn.operation === 'push') {
			if (object?.[key] === undefined) {
				object[key] = []
			}
			object[key] = [...object?.[key], updateParamsIn.value]
		} else if (updateParamsIn.operation === 'pop') {
			object?.[key]?.pop()
		} else if (updateParamsIn.operation === 'replace') {
			object[updateParamsIn.value] = object?.[key]
			delete object?.[key]
		}
		return object
	} else {
		let keyPath = [...updateParamsIn.keyPath]
		const key2 = keyPath?.[0]
		keyPath.shift()
		let updateParamsOut: UpdateObjParams = {
			object: updateParamsIn.object[key2],
			keyPath: keyPath,
			value: updateParamsIn.value,
			operation: updateParamsIn.operation,
		}
		const ret = updateObj(updateParamsOut)
		let object
		if (Array.isArray(updateParamsIn.object)) {
			object = [...updateParamsIn.object]
		} else {
			object = { ...updateParamsIn.object }
		}
		object[key2] = ret
		return object
	}
}*/
